@if (isOneUpgrade) {
  <app-workflow-upgrade-one></app-workflow-upgrade-one>
}
@if (isCancelSubscription) {
  <app-workflow-cancel-subscription></app-workflow-cancel-subscription>
}
@if (isPhonenumbers) {
  <app-workflow-phonenumbers></app-workflow-phonenumbers>
}
@if (isItemizedBilling) {
  <app-workflow-itemized-billing></app-workflow-itemized-billing>
}
@if (isTariff) {
  <app-workflow-tariff></app-workflow-tariff>
}
@if (isTariffCancel) {
  <app-workflow-tariff-cancel></app-workflow-tariff-cancel>
}
@if (!isInWorkflow) {
  <div>
    <a routerLink="/">{{'not_in_workflow_link' | i18next}}</a>
  </div>
}
